import { render, staticRenderFns } from "./ShopSubcategory.vue?vue&type=template&id=de7aa21c&scoped=true&"
import script from "./ShopSubcategory.vue?vue&type=script&lang=js&"
export * from "./ShopSubcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7aa21c",
  null
  
)

export default component.exports